import React from 'react'
import clsx from 'clsx'
import { Clear } from '@mui/icons-material'
import Tag2Icon from '../../../../icons/Tag2Icon'

import useStyles from './styles'

const TagV2 = ({
  tag,
  onClick = undefined,
  onDelete = undefined,
  hideIcon = false
}) => {
  const classes = useStyles()

  const handleClickDelete = e => {
    e.stopPropagation()
    onDelete(tag)
  }

  return (
    <div onClick={onClick} className={classes.root}>
      {!hideIcon && (
        <Tag2Icon
          fill='#8F8F8F'
          className={clsx(classes.icon, classes.tagIcon)}
        />
      )}

      <label>{tag}</label>

      {onDelete && (
        <Clear
          onClick={handleClickDelete}
          fill='#8F8F8F'
          className={clsx(classes.removeTagIcon, classes.muiIcon)}
        />
      )}
    </div>
  )
}

export default TagV2
